import React, { FunctionComponent, useEffect } from 'react';
import Themes from '@ro-sources/themes';
import OlLayerTile from 'ol/layer/Tile';

interface TileProps {
  defaultTile: string;
  tile: OlLayerTile;
}

const Tile: FunctionComponent<TileProps> = ({ defaultTile, tile }) => {
  useEffect(() => {
    const source = tile.getSource();
    tile.setOpacity(Themes[defaultTile].opacity);
    (source as any).setUrl(Themes[defaultTile].link);
    source.refresh();
    (tile as any).class = 'tile';
  }, [defaultTile, tile]);

  return <></>;
};

export default Tile;
